'use strict';

(function() {
	angular.module('pphhApp')
		.controller('GisController', ['$scope', '$mdDialog', "GisService", GisController]);

	angular.module('pphhApp')
		.controller('GisSelectionController', ["$scope", "selectionHolder","parentController", "$mdDialog", "$window",
			"GisService", "SessionStorageService", "pphhEnv", GisSelectionController]);

	/**
	 * Controlador que gestiona la interacción del usuario con el visor alfanumérico.
	 */
	function GisController($scope, $mdDialog, gisService) {
		var open = false;

		var unbindGisRequiredEvent = null;

		var gisSelectionHolder = new GisSelectionHolder();
		//17507 Añadido para el refresco al borrar elementos
		var elementDeleted = false;

		$scope.toggleMap = false;

		$scope.init = init;
		$scope.onOpenViewer = onOpenViewer;
		$scope.showGroupOnGis = showGroupOnGis;
		$scope.showAllGroupsOnGis = showAllGroupsOnGis;
		$scope.close = close;
		$scope.showSelectionDialog = showSelectionDialog;
		$scope.dialogElementDeleted = dialogElementDeleted;

		unbindGisRequiredEvent = $scope.$on("GIS_REQUIRED", function(event, args) {
			$scope.toggleMap = true;

			var opType = args.type;
			var payload = args.payload;
			if (opType === "openEmpty") {
				showOnGis(payload);
			} else if (opType === "elementAdded") {
				refreshAndShowOnGis(payload.selectionInfo, payload.addedElement);
			} else if (opType === "reloadElements") {
				//17507 Añadido para el refresco al borrar elementos
				if ( !payload.addedElement ){
					var activeEntity = gisSelectionHolder.getActiveEntity ();
					payload.addedElement = {};
					payload.addedElement.entityType = activeEntity.entityType;
					payload.addedElement.id = gisSelectionHolder.getActiveIds();
				}
				clearEntityGis(payload.addedElement.entityType);
				refreshAndShowOnGis(payload.selectionInfo, payload.addedElement, payload);
			} else if (opType === "hideMap") {
				//17507 Añadido para el refresco al borrar elementos
				close ();
			} else {
				refreshAndShowOnGis(payload.selectionInfo);				
			}
		});


		$scope.$on("$destroy", function() {
			unbindGisRequiredEvent();
			unbindGisRequiredEvent = null;
		});

		function init() {
			gisService.getSelection().then(function(selection) {
				refreshAndShowOnGis(selection);
			});
		}

		function onOpenViewer() {
			open = true;

			showOnGis();
		}

		var waitingMessage = null;
		function showOnGis(message) {
			if (!open) {
				waitingMessage = message;
			} else {
				if (!message) {
					message = waitingMessage;
					waitingMessage = null;
				}
				MagramaViewer.send(message);
			}
		}

		function clearEntityGis(entityType){
			var currentGroupViews = gisSelectionHolder.selectionGroups;

			var groupViewsToRemove = currentGroupViews.filter(group => group.entityType === entityType);

			groupViewsToRemove.forEach(group => gisSelectionHolder.deleteGroup(group));
		}

		function refreshAndShowOnGis(groups, addedElementRef, payload) {
			var currentGroupViews = gisSelectionHolder.selectionGroups;

			angular.forEach(groups, function(group) {
				var groupView = computeGroupViewIfAbsent(currentGroupViews, group);
				groupView.message = group.message;
				groupView.router = group.router;
				createElementViews(groupView, group.elements);
			});

			gisSelectionHolder.setSelectionGroups(currentGroupViews);

			if (addedElementRef) {
				var foundGroupView = findGroupByElementRef(currentGroupViews, addedElementRef);
				var foundElementView = findElementView(foundGroupView, addedElementRef.id);

				if (foundGroupView == null){					
					showOnGis(payload);
				}else {
					gisSelectionHolder.setActiveFlagElementView(foundElementView);
					if (foundGroupView.message) {
						showOnGis(foundGroupView.message);
					} else {
						showOnGis(foundElementView.message);
					}
				}
			}
		}

		function showGroupOnGis(groupView) {
			showOnGis(groupView.message);
		}

		function showAllGroupsOnGis(groupsView) {
			var allGroupsMessage = {...groupsView[0].message};
			allGroupsMessage.eventos = [];

			angular.forEach(groupsView, function(group){
				angular.forEach(group.message.eventos, function(evento){
					allGroupsMessage.eventos.push(evento)
				});
			});

			showOnGis(allGroupsMessage);
		}

		function findGroupByElementRef(groupViews, addedElementRef) {
			var groupViewFound = null;
			angular.forEach(groupViews, function(groupView) {
				if (groupView.entityType === addedElementRef.entityType
					&& findElementView(groupView, addedElementRef.id) != null) {
					groupViewFound = groupView;
				}
			});

			return groupViewFound;
		}

		function computeGroupViewIfAbsent(currentGroupViews, group) {
			var groupViewFound = findGroupView(currentGroupViews, group.code);

			if (groupViewFound == null) {
				groupViewFound = {
					code: group.code,
					displayLabel: group.displayLabel,
					entityType: group.entityType,
					entityTypeDisplayLabel: group.entityTypeDisplayLabel
				};

				currentGroupViews.push(groupViewFound);
			}

			return groupViewFound;
		}

		function findGroupView(groupViews, groupCode) {
			var groupViewFound = null;
			angular.forEach(groupViews, function(groupView) {
				if (groupView.code === groupCode) {
					groupViewFound = groupView;
				}
			});

			return groupViewFound;
		}

		function createElementViews(groupView, elements) {
			var copyOfElements = [];

			angular.forEach(elements, function(element) {
				var elementView = findElementView(groupView, element.id);
				if (elementView != null) {
					groupView.changed++;

				} else {
					elementView = createElementView(element);
				}

				copyOfElements.push(elementView);
			});

			groupView.elements = copyOfElements;
		}

		function findElementView(groupView, elementId) {
			var ids = null;
			if (Array.isArray(elementId) ) {
				ids = elementId;
			}
			else {
				ids = [elementId];
			}
			var foundElementView = null;
			if (groupView != null){
				angular.forEach(groupView.elements, function(currentElementView) {
					if ( ids.includes ( currentElementView.id)) {
						foundElementView = currentElementView;
					}
				});
			}
			return foundElementView;
		}

		function createElementView(element) {
			return {
				id: element.id,
				code: element.code,
				description: element.description,
				latitud: element.latitude,
				longitud: element.longitude,
				invalid: element.invalid,
				invalidCause: element.invalidCause,
				show: true,
				message: element.message
			};
		}

		function close() {
			//17507 Añadido para el refresco al borrar elementos
			$mdDialog.hide();
			$scope.toggleMap = false;
		}

		function showSelectionDialog() {
			$mdDialog.show({
				controller: "GisSelectionController",
				templateUrl: "/gis/selection/template",
				parent: angular.element(document.body),
				clickOutsideToClose: true,		
				locals: {
					selectionHolder: gisSelectionHolder,
					//17507 Añadido para el refresco al borrar elementos
					parentController: this
				}
			}).then(function(action) {
				
				if (action.name === "geolocationGroup") {
					showGroupOnGis(action.group);
				} else if (action.name === "geolocationAllGroups") {
					showAllGroupsOnGis(action.groups);
				} else if (action.name === "geolocationElement") {
					showOnGis(action.element.message);
				}
			}, function () {
				//17507 Añadido para el refresco al borrar elementos
				if ( elementDeleted ){
					dialogElementDeleted ( false);
					gisService.getSelection().then(function(selectionInfo) {
						var ids = gisSelectionHolder.getActiveIds();
						var entityType = gisSelectionHolder.getActiveEntity ().entityType;	
						if ( ids.length < 1 ){
							var group = gisService.findGroupByEntityType ( gisService.getSavedIds(),entityType);
							ids = group.ids; 
						}
						var payload = {
							selectionInfo: selectionInfo,
							addedElement: {
								entityType: entityType,
								id: ids
							}							
						}
						clearEntityGis(payload.addedElement.entityType);
						refreshAndShowOnGis(payload.selectionInfo, payload.addedElement, payload);
					});
				}				
				
			});
		}
		//17507 Añadido para el refresco al borrar elementos
		function dialogElementDeleted ( valor ){
			elementDeleted = valor;
		}
	}

	function GisSelectionController($scope, selectionHolder,parentController, $mdDialog, $window, gisService,
		sessionStorageService, pphhEnv) {

		$scope.groupsByEntityType = [];
		$scope.selectionGroups = [];

		$scope.init = init;
		$scope.showGroupOnGis = showGroupOnGis;
		$scope.showAllGroupsOnGis = showAllGroupsOnGis;
		$scope.showElementOnGis = showElementOnGis;
		$scope.deleteElement = deleteElement;
		$scope.deleteGroup = deleteGroup;
		$scope.navigate = navigate;		

		$scope.$watch("selectionGroups", groupingByEntityType, true);

		function init() {
			$scope.selectionGroups = selectionHolder.selectionGroups;
		}

		function groupingByEntityType() {
			$scope.groupsByEntityType = [];
			$scope.groupsByEntityType = selectionHolder.groupingByEntityType();
		}

		function showGroupOnGis(group) {
			selectionHolder.setActiveFlagGroupView(group);

			$mdDialog.hide({
				name: "geolocationGroup",
				group: group
			});
		}

		function showAllGroupsOnGis(groups){

			selectionHolder.setActiveFlagAllGroupsView(groups);

			$mdDialog.hide({
				name: "geolocationAllGroups",
				groups: groups
			});
		}

		function showElementOnGis(element) {
			selectionHolder.setActiveFlagElementView(element);

			$mdDialog.hide({
				name: "geolocationElement",
				element: element
			});
		}

		function deleteElement(group, element) {
			gisService.deleteElement(group.entityType, element.id);
			selectionHolder.deleteElement(group, element);
			//17507 Añadido para el refresco al borrar elementos
			parentController.dialogElementDeleted(true);
		}

		function deleteGroup(group) {
			gisService.deleteGroup ( group );
			selectionHolder.deleteGroup(group);
			//17507 Añadido para el refresco al borrar elementos
			parentController.dialogElementDeleted(true);
		}

		function navigate(endpoint) {
			if (endpoint.type === "MODULE_VIEWER") {
				sessionStorageService.saveObj("moduleEndpoint", endpoint);
			}

			$window.location.href = pphhEnv.global.contextPath + endpoint.urlFragment;
		}
	}

	/**
	 * Componente de utilidad que permite gestionar el listado de selecciones
	 * del usuario.
	 */
	function GisSelectionHolder(groupViewArray) {
		var self = this;

		self.groupsByEntityType = [];

		self.selectionGroups = [];
		if (groupViewArray) {
			self.selectionGroups = groupViewArray;
		}

		self.setSelectionGroups = setSelectionGroups;
		self.groupingByEntityType = groupingByEntityType;
		self.resetActiveFlags = resetActiveFlags;
		self.setActiveFlagGroupView = setActiveFlagGroupView;
		self.setActiveFlagElementView = setActiveFlagElementView;
		self.setActiveFlagAllGroupsView = setActiveFlagAllGroupsView;
		self.unsetActiveFlagElementView = unsetActiveFlagElementView;
		self.deleteElement = deleteElement;
		self.deleteGroup = deleteGroup;
		//17507 Añadido para el refresco al borrar elementos
		self.getActiveEntity = getActiveEntity;
		self.getActiveIds = getActiveIds;
		self.getEntityGroups = getEntityGroups;

		function setSelectionGroups(groupViews) {
			self.selectionGroups = groupViews;
		}

		function groupingByEntityType() {
			self.groupsByEntityType = [];
			angular.forEach(self.selectionGroups, function(groupView) {
				var groupByEntityType = computeGroupingByEntityType(groupView);
				groupByEntityType.groups.push(groupView);
			});

			computeActiveFlag();

			return self.groupsByEntityType;
		}

		function computeGroupingByEntityType(groupView) {
			var groupByEntityTypeFound = null;

			angular.forEach(self.groupsByEntityType, function(groupByEntityType) {
				if (groupByEntityType.entityType === groupView.entityType) {
					groupByEntityTypeFound = groupByEntityType;
				}
			})

			if (groupByEntityTypeFound == null) {
				groupByEntityTypeFound = {
					entityType: groupView.entityType,
					displayLabel: groupView.entityTypeDisplayLabel,
					groups: [],
					active: false
				};

				self.groupsByEntityType.push(groupByEntityTypeFound);
			}

			return groupByEntityTypeFound;
		}

		function computeActiveFlag() {
			if (self.groupsByEntityType.length > 0) {
				var anyActive = false;
				angular.forEach(self.groupsByEntityType, function(groupByEntityType) {
					checkEntityTypeActive(groupByEntityType);

					anyActive = anyActive || groupByEntityType.active;
				});

				if (!anyActive) {
					self.groupsByEntityType[0].active = true;
				}
			}
		}

		function checkEntityTypeActive(groupByEntityType) {
			groupByEntityType.active = false;
			angular.forEach(groupByEntityType.groups, function(groupView) {
				checkGroupViewActive(groupView);
				groupByEntityType.active = groupByEntityType.active || groupView.active;
			});
		}

		function checkGroupViewActive(groupView) {
			groupView.active = false;
			angular.forEach(groupView.elements, function(elementView) {
				groupView.active = groupView.active || elementView.active;
			});
		}

		function resetActiveFlags() {
			//17507 Añadido para el refresco al borrar elementos
			self.groupingByEntityType();			
			angular.forEach(self.groupsByEntityType, function(groupByEntityType) {
				groupByEntityType.active = false;
				resetGroupViewActiveFlags(groupByEntityType.groups);
			});
		}

		function resetGroupViewActiveFlags(groupViews) {
			angular.forEach(groupViews, function(groupView) {
				groupView.active = false;
				resetElementViewActiveFlags(groupView.elements);
			});
		}

		function resetElementViewActiveFlags(elementViews) {
			angular.forEach(elementViews, function(elementView) {
				elementView.active = false;
			});
		}

		function setActiveFlagGroupView(group) {
			resetActiveFlags();
			angular.forEach(group.elements, function(elementView) {
				elementView.active = true;
			});
			computeActiveFlag();
		}

		function setActiveFlagAllGroupsView(groups) {
			resetActiveFlags();

			angular.forEach(groups, function(group){
				angular.forEach(group.elements, function(elementView) {
					elementView.active = true;
				});
			});

			computeActiveFlag();
		}

		function setActiveFlagElementView(element) {
			resetActiveFlags();
			element.active = true;
			computeActiveFlag();
		}

		function unsetActiveFlagElementView(element) {
			element.active = false;
			computeActiveFlag();
		}

		function deleteElement(group, element) {
			var prevActive = element.active;
			
			
			if ( prevActive == true ){
				unsetActiveFlagElementView(element);
			}

			var index = group.elements.indexOf(element);
			group.elements.splice(index, 1);

			if (group.elements.length === 0) {
				deleteGroup(group);
			}
			else{
				//17507 Añadido para el refresco al borrar elementos
				if ( prevActive == true ){
					// comprobamos si hay algun otro elemento activo en el grupo y si no lo hay 
					// ponemos el primero como activo
					// si el elemento borrado estaba activo.
					var existsActive = false;
					angular.forEach(group.elements, function(elementView) {
						if (elementView.active){ 
							existsActive = existsActive || elementView.active;
						}
					});
					if ( existsActive == false){
						group.elements[0].active=true;
						computeActiveFlag();
					}					
				}
			}
		}

		
		function deleteGroup(group, autoselect = true) {
			//17507 Añadido para el refresco al borrar elementos
			var prevGroupActive = false;			
			if ( group.active ){
				prevGroupActive=true;
				group.active = false;				
			}
			var index = self.selectionGroups.indexOf(group);
			self.selectionGroups.splice(index, 1);
			//17507 Añadido para el refresco al borrar elementos
			// si hay mas grupos de la entidad seleccionamos el primero
			if ( autoselect ) {
				var entityGroups = self.getEntityGroups(group.entityType);
				if ( prevGroupActive == true && entityGroups.length > 0 ){
					entityGroups[0].elements[0].active = true;
					computeActiveFlag();
				}		
			}				
		}
		//17507 Añadido para el refresco al borrar elementos
		function getActiveEntity (){
			var activeGroup = null;
			if ( self.groupsByEntityType ){
				var bucle = 0;				
				for ( bucle = 0; bucle < self.groupsByEntityType.length; bucle ++ ){
					if ( self.groupsByEntityType[bucle].active == true ){
						activeGroup = self.groupsByEntityType[bucle];
						bucle = self.groupsByEntityType.length; 
					}
				}
			}
			return activeGroup;
		}
		//17507 Añadido para el refresco al borrar elementos
		function getActiveIds (){
			var ids = [];
			var activeEntity = getActiveEntity ();
			angular.forEach(activeEntity.groups, function(group) {
				if ( group.active == true){
					angular.forEach(group.elements, function (element){
						if ( element.active == true ){
							ids.push ( element.id);
						}
					});
				}
			});
			return ids;
		}
		//17507 Añadido para el refresco al borrar elementos
		// Funcion que devuelve todos los grupos de una entidad.
		function getEntityGroups ( entityType){
			var groups =[];
			var index = 0;		
			self.groupingByEntityType();
			for ( index = 0; index < self.groupsByEntityType.length; index++){
				var currentGroups = self.groupsByEntityType[index];
				if( currentGroups.entityType == entityType ){
					groups = currentGroups.groups;
				}
			}	

			return groups;
		}
	}
})();